// Generated by purs version 0.15.10
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonInt);
var tcpi_total_retransIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_total_retrans";
    }
};
var tcpi_rcv_ooopackIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_rcv_ooopack";
    }
};
var tcpi_dsack_dupsIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_dsack_dups";
    }
};
var tcpi_data_segs_outIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_data_segs_out";
    }
};
var tcpi_data_segs_inIsSymbol = {
    reflectSymbol: function () {
        return "tcpi_data_segs_in";
    }
};
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(tcpi_total_retransIsSymbol)())(tcpi_rcv_ooopackIsSymbol)())(tcpi_dsack_dupsIsSymbol)())(tcpi_data_segs_outIsSymbol)())(tcpi_data_segs_inIsSymbol)())());
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt));
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(tcpi_total_retransIsSymbol)()())(tcpi_rcv_ooopackIsSymbol)()())(tcpi_dsack_dupsIsSymbol)()())(tcpi_data_segs_outIsSymbol)()())(tcpi_data_segs_inIsSymbol)()())());
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var LinuxTcpInfo = /* #__PURE__ */ (function () {
    function LinuxTcpInfo(value0) {
        this.value0 = value0;
    };
    LinuxTcpInfo.create = function (value0) {
        return new LinuxTcpInfo(value0);
    };
    return LinuxTcpInfo;
})();
var encodeJsonTcpInfo = {
    encodeJson: function (v) {
        return encodeJson(v.value0);
    }
};
var decodeJsonTcpInfo = {
    decodeJson: function (json) {
        return bind(decodeJson(json))(function (linuxTcpInfo) {
            return pure(new LinuxTcpInfo(linuxTcpInfo));
        });
    }
};
var toTranmissionStatsResult = function (v) {
    var mkTransStats = function (v1) {
        return {
            sent: new Data_Maybe.Just({
                lost: new Data_Maybe.Just(v1.tcpInfo.value0.tcpi_total_retrans),
                total: v1.tcpInfo.value0.tcpi_data_segs_out
            }),
            received: new Data_Maybe.Just({
                outOfOrder: new Data_Maybe.Just(v1.tcpInfo.value0.tcpi_rcv_ooopack),
                duplicate: new Data_Maybe.Just(v1.tcpInfo.value0.tcpi_dsack_dups),
                total: v1.tcpInfo.value0.tcpi_data_segs_in
            })
        };
    };
    return {
        startStats: mkTransStats(v.startStats),
        latestStats: mkTransStats(v.latestStats)
    };
};
export {
    LinuxTcpInfo,
    toTranmissionStatsResult,
    decodeJsonTcpInfo,
    encodeJsonTcpInfo
};
